module.exports = __webpack_public_path__ + "static/media/Grupo 11452@2x.82cec0a8.png";